@if (count > 0) {
  <div class="uncategorized-notice">
    <i class="ph ph-warning" aria-hidden="true"></i>
    <span class="uncategorized-notice__text">
      @if (count === 1) {
        <strong>{{ 'tenders.responses.documents.uncategorized-banner-one-lead' | translate }}</strong>
        <span>{{ 'tenders.responses.documents.uncategorized-banner-one-hint' | translate }}</span>
      } @else {
        <strong>{{ 'tenders.responses.documents.uncategorized-banner-many-lead' | translate: { count } }}</strong>
        <span>{{ 'tenders.responses.documents.uncategorized-banner-many-hint' | translate }}</span>
      }
    </span>
  </div>
}
